/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Dialog_DescriptionInputs */

const en_cookie_dialog_description = /** @type {(inputs: Cookie_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize your privacy settings here. You can choose which types of cookies and tracking technologies you allow.`)
};

const lv_cookie_dialog_description = /** @type {(inputs: Cookie_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šeit varat pielāgot privātuma iestatījumus un izvēlēties, kuras sīkdatnes un izsekošanas tehnoloģijas atļaut.`)
};

/**
* | output |
* | --- |
* | "Customize your privacy settings here. You can choose which types of cookies and tracking technologies you allow." |
*
* @param {Cookie_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_dialog_description = /** @type {((inputs?: Cookie_Dialog_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Dialog_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_dialog_description(inputs)
	return en_cookie_dialog_description(inputs)
});